import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui';
import { FileIcon } from '../../../../components/ui/Icons';
import { API_ENDPOINTS } from '../../../../config/apiConfig';
import { normalizeFileName } from '../../../../components/ui/utils/fileNameEncoding';

const MyManualsFilesTab = ({ files = [], canView }) => {
  const { theme } = useTheme();
  const activeFiles = (files || []).filter((f) => !f.isDeleted);

  if (!canView) {
    return (
      <div className="p-4">
        <p className="text-sm text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 p-3 rounded-lg">
          Files are available when the manual status is Valid.
        </p>
      </div>
    );
  }

  if (!activeFiles.length) {
    return (
      <div className="p-4">
        <p className={cn('text-sm', theme.text.secondary)}>No attachments on this manual.</p>
      </div>
    );
  }

  return (
    <div className="p-4 flex-1 overflow-y-auto">
      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center">
            <FileIcon className="w-4 h-4 mr-2" />
            Manual files ({activeFiles.length})
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {activeFiles.map((file) => (
            <a
              key={file.id}
              href={`${API_ENDPOINTS.FILE_ATTACHMENT_DOWNLOAD}/${file.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className={cn(
                'flex items-center gap-2 text-sm p-2 rounded border hover:opacity-90',
                theme.border.light,
                theme.text.primary
              )}
            >
              <FileIcon className="w-4 h-4 shrink-0" />
              <span className="truncate">{normalizeFileName(file.fileName)}</span>
            </a>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};

export default MyManualsFilesTab;
